const resolution = {width: 540, height: 900};
const packFolder = "mobile_vertical/";
const pathFolder = "mobile_vertical/";

export const configGame_mobile_vertical = {
    packFolder: packFolder,
    pathFolder: pathFolder,
    type: "MobileVertical",

    Screen: {
        resolution: resolution,
        screen_ratio: resolution.width / resolution.height,
        loadscreen: {
            image: {name: "res/" + pathFolder + "loadscreen.png", rus: true},
            loadbar:{
                position: {x: 83, y: 668},
                image: "res/" + pathFolder + "loadbar.png"
            }
        }
    },

    MainScene: {
        frameUi: {pos: {x: 7, y: 363}},
        logoFix: {pos: {x: 105, y: 37}},
        logoX2: {pos: {x: 41, y: 37}},
        coin: {pos: {x: 137, y: 80}},
        animCoinOrel: {
            from: 7,
            frames: 13,
        },
        animCoinReshka: {
            from: 0,
            frames: 6,
        },
    },

    UiScene: {
        buttonSelectOrel: {pos: {x: 63, y: 560}},
        buttonSelectReshka: {pos: {x: 348, y: 560}},
        buttonGameMode: {pos: {x: 453, y: 722}},
        buttonMore: {pos: {x: 370, y: 601}},
        buttonStop: {pos: {x: 30, y: 601}},
        frameTotalBet: {
            visible: false,
            pos: {x: 14, y: 368},
            labelTotalBet: {
                pos: {x: 163, y: 103},
                font: {
                    name: "font_white_nums_mobile_vertical",
                    tint: 0x00ff66
                }
            },
            labelTotalBetBefore: {
                pos: {x: 0, y: 0},
                font: {
                    name: "arial_regular_16_mobile_vertical",
                }
            },
            labelTotalBetAfter: {
                pos: {x: 0, y: 0},
                font: {
                    name: "arial_regular_20_mobile_vertical",
                }
            },
            chooseOrel: {pos: {x: 37, y: 1}},
            chooseReshka: {pos: {x: 37, y: 8}},
        },
        labelResult: {
            pos: {x: 970, y: 245},
            font: {
                name: "arial_bold_32_mobile_vertical",
            }
        },
        labelCoeff: {
            pos: {x: 275, y: 655},
            font: {
                name: "font_coeff_mobile_vertical",
            }
        },
        imgSelectLightOrel: {pos: {x: 63, y: 560}},
        imgSelectLightReshka: {pos: {x: 348, y: 560}},
        animSelectLightOrel: {pos: {x: 67, y: 564}},
        animSelectLightReshka: {pos: {x: 352, y: 564}},
    },

    UiSceneList: {
        maxListSize: 4,
        startY: 460,
        offY: 30,
        layer: {pos: {x: 295, y: 0}},
        label: {
            pos: {x: 180, y: 0},
            font: {
                name: "font_list_nums_mobile_vertical",
                align: "left",
                anchor: {x: 1.0, y: 0.5}
            }
        },
        labelCurrency: {
            pos: {x: 230, y: 17},
            font: {
                name: "arial_regular_16_currency_mobile_vertical",
                align: "left",
                anchor: {x: 1.0, y: 0.5}
            }
        },
    },

    Settings: {
        background: {pos: {x: -12, y: 38}},
        backgroundTitle: {pos: {x: 136, y: 50}},
        countImg: 6,
        grid: {
            startPos: {x: 108, y: 230},
            stepLength: {x: 172, y: 240},
            scale: {x: 0.29, y: 0.25},
        },
        buttonOk: {pos: {x: 195, y: 610}},
    },

    AccountChangedWindow: {
        background: {pos: {x: -12, y: 38}},
        buttonOk: {pos: {x: 147, y: 610}},
        labelTitle: {
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        }
    },

    Help: {
        background: {pos: {x: -12, y: 38}},
        backgroundTitle: {pos: {x: 168, y: 62}},
        buttonOk: {pos: {x: 147, y: 610}},
        labelTitle: {
            pos: {x: 280, y: 120},
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        },
        labelTitle0: {
            pos: {x: 100, y: 230},
            font: {
                fontFamily: "Arial",
                fontSize: 36,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo: {
            pos: {x: 25, y: 235},
            font: {
                fontFamily: "Arial",
                fontSize: 18,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelTitle1: {
            pos: {x: 100, y: 410},
            font: {
                fontFamily: "Arial",
                fontSize: 36,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo1: {
            pos: {x: 25, y: 415},
            font: {
                fontFamily: "Arial",
                fontSize: 18,
                fill: 0xffffff,
                align: "left"
            }
        },
        translateList: {
            name: {
                rus: 'Игра «Орел или Решка»',
                eng: 'Game «Flip the coin»'
            },
            mode: {
                rus: 'Фиксированная ставка',
                eng: '            Fix bet'
            },
            info: {
                rus: '    Определяетесь с размером ставки и бросаете монетку.\n' +
                '                            Угадали? Поздравляем!\n' +
                '                   Ваша ставка увеличивается в 2 раза!\n',
                eng: '    Choose either head or tail and select the value of your bet.\n' +
                '                   Then flip the coin. Did you guess right?\n' +
                '                                If yes, your bet is doubled!\n'
            },
            mode1: {
                rus: 'Удвоение ставки',
                eng: '            Doubling bet'
            },
            info1: {
                rus: '     Вы выбираете Орла или Решку и делаете ставку 50 RUB.\n' +
                '                             Угадали?\n' +
                '          Можете забрать выигрыш 100 RUB или бросить еще раз...\n',
                eng: '    Choose .\n'
            },
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_vertical/game.es6
// module id = 43
// module chunks = 0